import { render, staticRenderFns } from "./ServiceWarehouses.vue?vue&type=template&id=0a339817&"
import script from "./ServiceWarehouses.vue?vue&type=script&lang=js&"
export * from "./ServiceWarehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports